var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('VehicleModelIndex',{attrs:{"fstId":"org-vehicle-model-index","endpoint":_vm.getUrl,"roleType":_vm.getRoleType,"isHidePlus":_vm.getHidePlusStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }